import { IApplicationState, IGame } from '@spinwise/spinwise-core';
import { useEffect, useState } from 'react';
import styles from './CarouselAuto.module.scss';

import { useSelector } from 'react-redux';
import GameThumbnailManager from '../GameThumbnailManager/GameThumbnailManager';
import classNames from 'classnames';
export interface ICarouselAuto {
  gameList: Array<any>;
  imgWidthDesktop: number;
  imgWidthMobile: number;
  sliderHeight: string;
  sliderWidth: string;
  sliderOverflowX: any;
  gridGap: string;
  gamesListLength: number;
}
// const imgWidthDesktop: number = 330;
// const imgWidthMobile: number = 225;

const CarouselAuto = (props: ICarouselAuto) => {
  useEffect(() => {
    cutArrayUntilNElements(props.gameList, props.gamesListLength);
  }, [props.gameList]);
  const { integrationKeys } = useSelector((state: IApplicationState) => state.globalReducer);
  const [gameList, setGameList] = useState([]);

  const getIntegration = item => {
    let integrationKey = integrationKeys.keys?.[item.urlKey];

    return integrationKey ?? false;
  };
  const cutArrayUntilNElements = (list: Array<any>, count: number) => {
    if (list.length == count) {
      setGameList(list);
    } else {
      for (let i = 0; i < list.length; i++) {
        if (list.length <= count) {
          setGameList(list);
          return;
        }

        list.pop();
      }
    }
  };

  const isAdvancedThumbnail = () => {
    if (typeof integrationKeys?.keys === 'boolean' && integrationKeys?.keys !== undefined) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      {gameList.length > 0 && integrationKeys && (
        <div
          className={classNames(styles.slider, { [styles.slider__advanced]: isAdvancedThumbnail })}
          style={{
            height: props.sliderHeight,
            width: props.sliderWidth,
            overflowX: props.sliderOverflowX,
          }}
        >
          <div
            className={`${styles.slide_track_m}`}
            style={
              {
                '--gamesListLength': props.gamesListLength,
              } as React.CSSProperties
            }
          >
            <div className={`${styles.slide} d-fl`} style={{ gap: props.gridGap }}>
              {gameList.map((item: IGame, i: number) => {
                let integrationKey = getIntegration(item);
                return (
                  <GameThumbnailManager
                    key={item?.eid}
                    game={item}
                    integrationKeys={integrationKey}
                    size={226}
                  ></GameThumbnailManager>
                );
              })}
              {gameList.map((item: IGame, i: number) => {
                let integrationKey = getIntegration(item);
                return (
                  <GameThumbnailManager
                    key={item?.eid}
                    game={item}
                    integrationKeys={integrationKey}
                    size={226}
                  ></GameThumbnailManager>
                );
              })}
            </div>
          </div>
          <div
            className={`${styles.slide_track_d}`}
            style={
              {
                '--gamesListLength': props.gamesListLength,
              } as React.CSSProperties
            }
          >
            <div className={`${styles.slide} d-fl`} style={{ gap: props.gridGap }}>
              {gameList.map((item: IGame, i: number) => {
                let integrationKey = getIntegration(item);
                return (
                  <GameThumbnailManager
                    key={item?.eid}
                    game={item}
                    integrationKeys={integrationKey}
                    size={320}
                  ></GameThumbnailManager>
                );
              })}
              {gameList.map((item: IGame, i: number) => {
                let integrationKey = getIntegration(item);
                return (
                  <GameThumbnailManager
                    key={item?.eid}
                    game={item}
                    integrationKeys={integrationKey}
                    size={320}
                  ></GameThumbnailManager>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default CarouselAuto;
